import { isDesktop } from '@zola-helpers/client/dist/es/util/responsive';
import { INIT_NAV_DATA } from 'constants/navConstants';

export const emitUpdateNavDataEvent = ({
  userContext,
  secondaryData,
  activePrimaryLink,
  activeSecondaryLink,
  disablePrimaryNavCollapse,
  disablePromoNavCollapse,
  emitDirectionEvents,
}) => {
  window.dispatchEvent(
    new CustomEvent(INIT_NAV_DATA, {
      detail: {
        userContext,
        secondaryData,
        activePrimaryLink,
        activeSecondaryLink,
        disablePrimaryNavCollapse,
        disablePromoNavCollapse,
        emitDirectionEvents,
      },
    })
  );
};

export const getNavHeight = withSecondary => {
  if (isDesktop()) {
    return withSecondary ? 172 : 136;
  }
  return 60;
};

export default {
  emitUpdateNavDataEvent,
  getNavHeight,
};



// WEBPACK FOOTER //
// ./src/components/common/header/helpers.js